module.exports = __webpack_public_path__ + "img/app_store_patterns.7b4ec4ba.jpg";